import { z } from "zod";

/** The tabs of the Annotation page, which is open on the backlog unless a link says otherwise. */
export const ANNOTATION_TABS = [
  { value: "backlog", label: "Backlog" },
  { value: "improve-ranking", label: "Improve ranking" },
] as const;

/** What the Annotation page is told by its URL: which tab to open. */
export const annotationFiltersSchema = z.object({
  tab: z.enum(["backlog", "improve-ranking"]).default("backlog"),
});
